import { EditorMultiText } from "./MultiText";
import { SelectorItem } from "./SelectorItem";
import { FileContainer } from "./FileContainer";
import { ImageItem } from "./ImageItem";
import { TextItem } from "./TextItem";
import { MultiTextHead } from "./MultiTextHead";
import { Div } from "../Div";
import { Img } from "../Img";
import { toMap } from "../../../../HA";

export class EditorFile extends EditorMultiText {

    public getSelections() {
        const data = [];
        this.getItems().forEach((s: SelectorItem) => {
            if (s.isChecked()) {
                data.push(s.getValue());
            }
        });

        return data;
    }

    protected getItems() {
        return this.getList().getItems();
    }

    protected getList() {
        return this.get("list");
    }

    protected addFiles(files: any[]) {
        for (let i = 0; i < files.length; i++) {
            this.addFile(files[i]);
        }
    }

    protected addFile(file: any) {
        if (file && !this.getList().hasValue(file.name)) {
            const imgContainer = new FileContainer(toMap({f: file}));
            const div = new Div({className: "thumb"});
            div.appendChild(new Img(toMap({src: this.getFileIcon(file)})));
            imgContainer.appendChild(div);
            this.getList().addItem(new ImageItem(toMap({item: imgContainer, s: true})));
        }
    }

    protected getFileIcon(file: any): string {
        switch (file.type) {
            case "application/pdf":
                return "/file/ha/svg/file_pdf";
            case "application/json":
                return "/file/ha/svg/file_json";
            default:
                return "/file/ha/svg/file_pdf";
        }
    }

    protected createItem(data: any) {
        return new TextItem(data);
    }

    protected createHead(data?: any) {
        return new MultiTextHead(toMap({
            accept: ".json,application/json,.pdf,application/pdf",
            ed: {
                addFiles: (files?: any[]) => {
                    if (files) {
                        this.addFiles(files);
                    }
                },
            },
            t: "json",
        }));
    }
}
